import ReceiveViewContent from './ReceiveViewContent';

interface IProps {
  address: string;
  onClickCopyBtn: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const ReceiveView = ({ address, onClickCopyBtn }: IProps) => {
  return (
    <>
      <ReceiveViewContent address={address} onClickCopyBtn={onClickCopyBtn} />
    </>
  );
};

export default ReceiveView;
